<template>
  <div class="localDecry-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      :rules="editRules"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="私钥" prop="pri_key">
            <el-input v-model="formDate.pri_key" placeholder="请输入私钥"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="加密余额" prop="cipher_text">
            <el-input v-model="formDate.cipher_text" placeholder="请输入明文"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="余额">
            <el-input
              v-model="proclaimedTextEncryption"
              class="excellent-form-input readonly-text"
              readonly=""
              type="textarea"
              autosize=""
              disabled
            ></el-input>
            <el-button v-if="isChangeText" class="excellent-form-btn" @click.prevent="changeText()"
              >隐藏</el-button
            >
            <el-button v-if="!isChangeText" class="excellent-form-btn" @click.prevent="changeText()"
              >显示</el-button
            >
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="localEncryption()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      formDate: {
        cipher_text: '',
        pri_key: '',
        user_id: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID)
      },
      editRules: {
        pri_key: [{ required: true, message: '请输入私钥', trigger: 'blur' }],
        cipher_text: [{ required: true, message: '请输入密文', trigger: 'blur' }]
      },
      isChangeText: false,
      proclaimedTextDecryption: '', //显示文本
      proclaimedText: '', //后台返回后文本
      proclaimedTextEncryption: '', //加密
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {},
  methods: {
    localEncryption() {
      this.$refs.formDate.validate().then(valid => {
        if (valid) {
          this.formDate.cipher_text = this.formDate.cipher_text.replace(/\s/g, '')
          this.formDate.pri_key = this.formDate.pri_key.replace(/\s/g, '')

          this.$apis.encryption.decrypt(this.formDate).then(res => {
            if (res) {
              this.proclaimedTextEncryption = '********'
              this.proclaimedText = res.data
              this.$message.success('解密成功!')
            }
          })
        }
      })
    },
    changeText() {
      this.isChangeText = !this.isChangeText

      this.isChangeText
        ? (this.proclaimedTextEncryption = this.proclaimedText)
        : (this.proclaimedTextEncryption = '********')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

.localDecry-wrapper {
  @include adaptation(
    (
      --common-gap-16: 16px
    )
  );
  /deep/ .el-form-item__content {
    display: flex;

    :not(:first-child) {
      margin-left: var(--common-gap-16);
    }
  }

  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}
</style>
